<template>
  <div class="jl-account-info-wrap">
    <div
      :class="[detailType && auctionInfo.order.orderStatus === 1?'jl-acc-info-box':'jl-acc-info-box no-has-wl']"
    >
      <div class="item-main">
        <p class="text-title">基本信息</p>
        <div class="main-box">
          <div class="main-top" v-if="detailType">
            <p class="text1">订单编号：{{auctionInfo.order.id}}</p>
            <p class="text2 success" v-if="auctionInfo.order.orderStatus === 1">已支付</p>
            <p class="text2 error" v-else-if="auctionInfo.order.orderStatus === 2">未支付</p>
            <p class="text2 error" v-else>已逾期</p>
          </div>
          <div class="main-contetn">
            <div class="fl-ground">
              <p class="text3 alt-label">拍品名称</p>
              <p class="text3">{{auctionInfo.name}}</p>
            </div>
            <div class="fl-ground">
              <p class="text3 alt-label">拍卖类型</p>
              <p class="text3">秒杀价拍卖</p>
            </div>
            <div class="fl-ground" v-if="detailType">
              <p class="text3 alt-label">应付金额</p>
              <p class="text3">￥ {{auctionInfo.order.orderPrice}}</p>
            </div>
            <div class="fl-ground" v-else>
              <p class="text3 alt-label">起拍价</p>
              <p class="text3">￥ {{auctionInfo.startPrice}}</p>
            </div>
            <div class="fl-ground">
              <p class="text3 alt-label">用户名</p>
              <p class="text3">{{userInfo.userName}}</p>
            </div>
            <div class="fl-ground">
              <p class="text3 alt-label">绑定手机号</p>
              <p class="text3">{{userInfo.phone}}</p>
            </div>
            <div class="fl-ground" v-if="detailType">
              <p class="text3 alt-label">账单到期时间</p>
              <p class="text3">{{auctionInfo.order.dueTime}}</p>
            </div>
            <div class="fl-ground" v-if="detailType">
              <p class="text3 alt-label">支付时间</p>
              <p class="text3">{{auctionInfo.order.payTime}}</p>
            </div>
          </div>
        </div>
        <div class="main-footer clearfix" v-if="detailType">
          <div class="main-footer-box">
            <div class="order-price-info">
              <span class="span-1">订单金额：</span>
              <span class="span-1 col-red">￥</span>
              <span class="span-1 col-red alt-price">{{auctionInfo.order.orderPrice}}</span>
            </div>
            <div v-if="auctionInfo.order.orderStatus === 2" class="order-pay-btn">立即支付</div>
          </div>
        </div>
      </div>
      <div class="item-right" v-if="auctionInfo.order.orderStatus === 1">
        <div class="right-box">
          <p class="text-title">物流明细</p>
          <div v-if="payType" class="text-info-wrap">
            <p class="text-status">已发货</p>
            <div class="right-cont1">
              <p class="text1">{{auctionInfo.order.logisticsName}}</p>
              <p class="text2">单号: {{auctionInfo.order.logisticsNumber}}</p>
            </div>
            <div class="right-info">
              <p class="r-info-title">收货信息</p>
              <div class="fl-ground">
                <p class="text-1 alt-1">收货人</p>
                <p class="text-1">{{auctionInfo.order.logisticsAddress.consignee}}</p>
              </div>
              <div class="fl-ground">
                <p class="text-1 alt-1">联系方式</p>
                <p class="text-1">{{auctionInfo.order.logisticsAddress.contactPhone}}</p>
              </div>
              <div class="fl-ground">
                <p class="text-1 alt-1">收货地址</p>
                <p class="text-1">{{auctionInfo.order.logisticsAddress.shippingAddress}}</p>
              </div>
              <div class="fl-ground">
                <p class="text-1 alt-1">邮编</p>
                <p class="text-1">{{auctionInfo.order.logisticsAddress.zipCode}}</p>
              </div>
              <div class="fl-ground">
                <p class="text-1 alt-1">备注</p>
                <p class="text-1"></p>
              </div>
            </div>
          </div>
          <div v-else class="text-none-info">
            <div class="text-none-info-box">
              <img src="../../../assets/img/zkj-none-more-info.png" alt />
              <p class="text-none">暂无更多信息</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "accountAuctionDetail",
  computed: {
    ...mapGetters(["userInfo", "auctionRecordItem"])
  },
  data() {
    const detailId = this.$route.params.id;
    return {
      payType: false, // false => 未支付
      detailType: true, // false => 没有生成订单的拍品
      auctionInfo: {},
      detailId: detailId
    };
  },
  created() {
    this.auctionRecordItem.forEach(element => {
      if (element.id == this.detailId) {
        this.auctionInfo = element;
      }
    });
    this.auctionInfo = this.auctionInfo ? this.auctionInfo : { order: {} };
    //order_status'订单状态 0 逾期 1 已支付 2未支付',
    this.payType =
      this.auctionInfo && this.auctionInfo.order.orderStatus == 1
        ? true
        : false;
  },
  beforeRouteLeave(to, from, next) {
    localStorage.setItem(
      "auctionRecordItem",
      JSON.stringify({
        order: { logisticsAddress: {} }
      })
    );
    next();
  }

  // destroyed() {
  //   localStorage.setItem("auctionRecordItem", "");
  // }
};
</script>

<style lang="scss" scoped>
.jl-acc-info-box {
  position: relative;
  padding-right: 300px;
  &.no-has-wl {
    padding-right: 0;
  }
  .item-main {
    position: relative;
    z-index: 10;
    background: #fff;
    min-height: 450px;
    padding: 25px 50px;
    box-shadow: 9px 0 14px rgba($color: #b8b8b8, $alpha: 0.1);
    .text-title {
      font-size: 18px;
      color: #333;
      margin-bottom: 20px;
    }
    .main-box {
      padding: 20px;
      background: #f8f8fb;
    }
    .main-top {
      position: relative;
      padding-bottom: 20px;
      border-bottom: 1px solid #e0e0e0;
      .text1 {
        font-size: 14px;
        color: #333;
      }
      .text2 {
        position: absolute;
        right: 5px;
        top: 0;
        font-size: 14px;

        padding-left: 16px;
        &.success {
          color: #007af4;
          &::before {
            background: #007af4;
          }
        }
        &.error {
          color: #e50011;
          &::before {
            background: #e50011;
          }
        }
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          margin-top: -3px;
        }
      }
    }
    .main-contetn {
      padding-top: 20px;
      .fl-ground {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .text3 {
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
          color: #333;
          &.alt-label {
            color: #666;
            width: 120px;
          }
        }
      }
    }
    .main-footer-box {
      float: right;
      margin-top: 16px;
      .order-price-info {
        display: inline-block;
        .span-1 {
          display: inline-block;
          font-size: 14px;
          color: #666;
          &.col-red {
            color: #e70819;
          }
          &.alt-price {
            font-size: 24px;
            margin-left: 5px;
          }
        }
      }
      .order-pay-btn {
        display: inline-block;
        width: 156px;
        height: 42px;
        line-height: 42px;
        color: #fff;
        text-align: center;
        background: #e50011;
        margin-left: 25px;
      }
    }
  }
  .item-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 300px;
    height: 100%;
    background: #fff;
    padding-left: 18px;
    .right-box {
      padding: 0 16px;
      .text-title {
        font-size: 18px;
        color: #333;
        padding-top: 25px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e0e0e0;
        margin-bottom: 20px;
      }
      .text-status {
        position: relative;
        font-size: 24px;
        color: #12a624;
        padding-left: 20px;
        margin-bottom: 24px;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          width: 8px;
          height: 8px;
          background: #12a624;
          border-radius: 4px;
          margin-top: -4px;
        }
      }
      .right-cont1 {
        margin-bottom: 30px;
        .text1 {
          font-size: 18px;
          color: #333;
          line-height: 30px;
        }
        .text2 {
          font-size: 14px;
          color: #666;
        }
      }
      .right-info {
        .r-info-title {
          font-size: 18px;
          color: #333;
          margin-bottom: 10px;
        }
        .fl-ground {
          position: relative;
          padding-left: 72px;
          margin-bottom: 12px;
          .text-1 {
            font-size: 14px;
            color: #333;
            line-height: 20px;
            &.alt-1 {
              position: absolute;
              left: 0;
              top: 0;
            }
          }
        }
      }
      .text-none-info-box {
        margin-top: 130px;
        text-align: center;
        .text-none {
          font-size: 14px;
          color: #666;
          margin-top: 18px;
        }
      }
    }
  }
}
</style>
